<template>
    <div class="reportsMap">
        <div class="container">
            <div class="center">
                <div class="center_header_title">
                    <span>{{title1}}</span>
                    <span class="headerTitle">{{title2}}</span>
                    <div class="helpDiv">
                        <b class="helpI"></b>
                        <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=28050660" 
                        target="_blank"
                        class="helpA">
                            帮助指引
                        </a>
                    </div>
                </div>
                <div class="center_foot_left">
                    <span>生成时间: {{generateTime}}</span>
                </div>
                <div class="center_foot_right">
                    <span>itsmops.autoai.com</span>
                </div>
                <p></p>
                <div class="center_container_left">
                    <el-date-picker
                        ref="datePicker"
                        v-model="value1"
                        type="daterange"
                        @change="showTime"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="margin: 0 auto 10px auto"
                        :disabled="pickerDisable"
                    >
                    </el-date-picker>
                    <el-button @click="clickShow" type="primary" style="margin-left: 20px">修改时间</el-button>
                    <el-button @click="exportTable(title2,value1[0],`—${value1[1]}`)" type="primary">导出表格</el-button>
                    <el-table :data="tableData"  border show-summary  id="out_export":summary-method="getSummaries"
                    >
                        <el-table-column prop="name" label="人员名称"     min-width="95"></el-table-column>
                        <el-table-column prop="close" label="及时关闭事件数" sortable  :sort-orders="sortList" min-width="120"></el-table-column>
                        <el-table-column prop="review" label="有满意度调查事件数" sortable  :sort-orders="sortList" min-width="120"></el-table-column>
                        <el-table-column prop="total" label="事件总数" sortable :sort-orders="sortList" min-width="120"></el-table-column>
                        <el-table-column prop="closeRate" label="及时关闭事件数占比" sortable :sort-orders="sortList" min-width="120"></el-table-column>
                        <el-table-column prop="reviewRate" label="满意度调查占比" sortable :sort-orders="sortList" min-width="120"></el-table-column>
                    </el-table>
                </div>
                <div class="center_container_right">
                    <div style="width: 100%;height: 300px" ref="chart" class="chart"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import services from '../serviceList.service'
    export default {

        data(){
            return{
                value1:'',
                tableData:[],
                sortList:['ascending', 'descending'],
                generateTime:'',
                title1:'服务台统计',
                title2:'事件是否及时关闭及满意度调查统计',
                group:'reception',
                dimension:['product','及时关闭事件数','有满意度调查事件数','事件总数','及时关闭事件数占比','满意度调查占比'],
                pickerDisable:true,    //时间选择器默认禁用
            }
        },
        created(){

        },
        mounted(){
            // this.initChart()
            this.getDeafultTime()
        },
        methods:{
            exportTable(name,startTime,endTime=''){
                this.$exportTable(name,startTime,endTime)
            },
            getDeafultTime(){
                let nowdays = new Date();
                let year = nowdays.getFullYear();
                let month = nowdays.getMonth();
                if(month==0) {
                    month=12;
                    year=year-1;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                let firstDay = year + "-" + month + "-" + "01";//上个月的第一天
                let myDate = new Date(year, month, 0);
                let lastDay = year + "-" + month + "-" + myDate.getDate();//上个月的最后一天
                let params={
                    group:this.group,
                    startTime:firstDay,
                    stopTime:lastDay
                }
                this.value1=[firstDay,lastDay]
                // console.log(params);
                this.getData(params)
            },
            //点击修改时间触发时间选择器focus事件
            clickShow(){
                this.pickerDisable=false
                this.$refs.datePicker.focus()
            },
            showTime(){
                // console.log(this.value1);
                let params={
                    group:this.group,
                    startTime:this.value1[0],
                    stopTime:this.value1[1]
                }
                this.getData(params)
                this.pickerDisable=true
            },
            getData(params){
                services.closeEventReview(params).then(res=>{
                    this.generateTime=res.generateTime
                    res.graphData.unshift(this.dimension)
                    //处理得到百分比数据
                    let data=this.getPercent(res)
                    this.graphData=data.graphData
                    this.tableData=data.tableData
                    this.initChart()
                    // this.initCharts2(this.graphData);
                })
            },
            //处理每行数据得到百分比数据
            getPercent(val){
                //处理graphData
                let graph =val.graphData
                let graphLength=graph.length
                for(let i=1;i<graphLength;i++){
                    graph[i][4]=(graph[i][4]*100).toFixed(0)
                    graph[i][5]=(graph[i][5]*100).toFixed(0)
                }
                //处理tableData
                let table=val.tableData
                let tableLength=table.length
                for(let i=0;i<tableLength;i++){
                    table[i].closeRate=(table[i].closeRate*100).toFixed(0)+'%'
                    table[i].reviewRate=(table[i].reviewRate*100).toFixed(0)+'%'
                }
                let data={
                    graphData:graph,
                    tableData:table
                }
                return data
            },
            //处理表格合计行的百分比数据
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];       //sums数组里的每一项对应合计行的每一列
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                });
                // console.log(sums);
                if (sums[3]!==0){//事件总数不能为0（分母不能为0）
                    sums[4]=((sums[1]/sums[3])*100).toFixed(0)+'%'
                    sums[5]=((sums[2]/sums[3])*100).toFixed(0)+'%'
                }
                return sums;
            },
            //渲染柱状图
            initChart(){
                let mychart=this.$echarts.init(this.$refs.chart);
                mychart.setOption({
                    legend: {},
                    tooltip: {},
                    dataset: {
                        source: this.graphData
                    },
                    xAxis: {type: 'category'},
                    yAxis: {},
                    dataZoom:[
                        {
                            type: 'inside',
                            show: true,
                            xAxisIndex: [0],

                        },
                        {
                            type: 'slider',
                            show: true,
                            xAxisIndex: [0],

                        },

                    ],
                    // Declare several bar series, each will be mapped
                    // to a column of dataset.source by default.
                    series: [
                        {
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top',
                                    formatter:'{@及时关闭事件数占比}%'
                                }
                            },
                        },
                        {
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top',
                                    formatter:'{@满意度调查占比}%'
                                }
                            },
                        },

                    ]
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .reportsMap{
        margin-top: 20px;
        width: 100%;
        height: auto;
        background: white;
        position: relative;
        overflow: hidden;
        .container{
            width: 90%;
            /*height: 80%;*/

            .center{
                width: 100%;
                min-height: 80%;
                height: auto;
                background: white;
                position: relative;
                margin: 4% 6%;

                border-top: 1px solid rgb(158,195,240);
                border-bottom: 1px solid rgb(158,195,240);
                .center_header_title{
                    position: absolute;
                    top: -26px;
                    left: 0;
                    color: black;
                    font-size: 16px;
                    .headerTitle{
                        margin-left: 20px;
                        color: #1890ff;
                    }

                }
                .center_container_left{
                    width: 50%;
                    margin: 20px 0 20px 0;

                }
                .center_container_right{
                    width: 50%;

                }
                .center_foot_left{
                    position: absolute;
                    bottom: -26px;
                    left: 0;
                    color: grey;
                    font-size: 16px;
                }
                .center_foot_right{
                    position: absolute;
                    bottom: -26px;
                    right: 0;
                    color: grey;
                    font-size: 16px;
                }
                p{
                    position: absolute;
                    top: -26px;
                    right: 0;
                    width: 100px;
                    height: 22px;
                    background: url('../../../../assets/icon_logo.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }

</style>
